import React from 'react';
import profileStyles from './UserProfile.module.scss';
import type { DirectorShip } from './ManagementUserProfile.types';
import { NOT_AVAILABLE_LABEL } from './managementUserProfileUtils';

const NotAvailableRow = () => (
    <div className={profileStyles.DirectorShip}>
        <span className={profileStyles.CellDash}>{NOT_AVAILABLE_LABEL}</span>
    </div>
);

export default NotAvailableRow;
